import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ContattiProvider } from './context/LeadContext';
import { SettingsProvider } from './context/SettingsContext';
import { UsersProvider } from './context/UsersContext';
import { ImportProvider } from './context/ImportContext';
import { OverviewProvider } from './context/OverviewContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import UserSettingsPage from './pages/UserSettingsPage';
import SettingsPage from './pages/SettingsPage';
import './style.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <AuthProvider>
    <SettingsProvider>
      <UsersProvider>
        <ImportProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            
            <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <ContattiProvider>
                    <OverviewProvider>
                        <HomePage />
                    </OverviewProvider>
                  </ContattiProvider>
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/users"
              element={
                <ProtectedRoute>
                  <UserSettingsPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        </ImportProvider>
      </UsersProvider>
    </SettingsProvider>
  </AuthProvider>
);
